const InputGroup = ({ groupClassName = '', children }) => {
  return <div className={`text-[14px] h-full ${groupClassName}`}>
    {children}
  </div>
}

export default InputGroup;
